import { basicChecks, calculateRatio } from "./shared";

export const validateToothLength = () => ({
  validator(_, value) {
    const error = basicChecks(value, "Tooth length");
    return error ? Promise.reject(error) : Promise.resolve();
  },
});

export const validatePulpLength = (getFieldValue) => ({
  validator(_, value) {
    const error = basicChecks(value, "Pulp length");
    if (error) return Promise.reject(error);

    const tooth = getFieldValue("max_tooth_length");
    if (tooth && parseFloat(value) >= parseFloat(tooth)) {
      return Promise.reject("Pulp length must be less than tooth length");
    }

    return Promise.resolve();
  },
});

export const validateRootLength = (getFieldValue) => ({
  validator(_, value) {
    const error = basicChecks(value, "Root length");
    if (error) return Promise.reject(error);

    const tooth = getFieldValue("max_tooth_length");
    if (tooth && parseFloat(value) >= parseFloat(tooth)) {
      return Promise.reject("Root length must be less than tooth length");
    }

    return Promise.resolve();
  },
});

export const validateRootWidthA = () => ({
  validator(_, value) {
    const error = basicChecks(value, "Root width level A");
    return error ? Promise.reject(error) : Promise.resolve();
  },
});

export const validatePulpWidthA = (getFieldValue) => ({
  validator(_, value) {
    const error = basicChecks(value, "Pulp width level A");
    if (error) return Promise.reject(error);

    const rootA = getFieldValue("root_width_level_a");
    if (rootA && parseFloat(value) >= parseFloat(rootA)) {
      return Promise.reject("Pulp width A must be less than Root width A");
    }

    return Promise.resolve();
  },
});

export const validateRootWidthB = (getFieldValue) => ({
  validator(_, value) {
    const error = basicChecks(value, "Root width level B");
    if (error) return Promise.reject(error);

    const rootA = getFieldValue("root_width_level_a");
    if (rootA && parseFloat(value) >= parseFloat(rootA)) {
      return Promise.reject("Root width B must be less than Root width A");
    }

    return Promise.resolve();
  },
});

export const validatePulpWidthB = (getFieldValue) => ({
  validator(_, value) {
    const error = basicChecks(value, "Pulp width level B");
    if (error) return Promise.reject(error);

    const rootB = getFieldValue("root_width_level_b");
    if (rootB && parseFloat(value) >= parseFloat(rootB)) {
      return Promise.reject("Pulp width B must be less than Root width B");
    }

    return Promise.resolve();
  },
});

export const validateRootWidthC = (getFieldValue) => ({
  validator(_, value) {
    const error = basicChecks(value, "Root width level C");
    if (error) return Promise.reject(error);

    const rootB = getFieldValue("root_width_level_b");
    if (rootB && parseFloat(value) >= parseFloat(rootB)) {
      return Promise.reject("Root width C must be less than Root width B");
    }

    return Promise.resolve();
  },
});

export const validatePulpWidthC = (getFieldValue) => ({
  validator(_, value) {
    const error = basicChecks(value, "Pulp width level C");
    if (error) return Promise.reject(error);

    const rootC = getFieldValue("root_width_level_c");
    if (rootC && parseFloat(value) >= parseFloat(rootC)) {
      return Promise.reject("Pulp width C must be less than Root width C");
    }

    return Promise.resolve();
  },
});

export const validateArRatio = (getFieldValue) => ({
  validator(_, value) {
    const root = getFieldValue("root_length");
    const rootA = getFieldValue("root_width_level_a");

    if (!root || !rootA) return Promise.resolve();

    const arRatio = calculateRatio(rootA, root);

    if (arRatio <= 0.2 || arRatio >= 0.55) {
      return Promise.reject(
        "Invalid root width level A (a) to root length (r) ratio"
      );
    }

    return Promise.resolve();
  },
});

export const validateAtRatio = (getFieldValue) => ({
  validator(_, value) {
    const tooth = getFieldValue("max_tooth_length");
    const rootA = getFieldValue("root_length");

    if (!tooth || !rootA) return Promise.resolve();

    const rtRatio = calculateRatio(rootA, tooth);

    if (rtRatio <= 0.5 || rtRatio >= 0.75) {
      return Promise.reject(
        "Invalid root length (r) and maximum tooth length (t) ratio"
      );
    }

    return Promise.resolve();
  },
});
